import { memo } from 'react'

import {
  CardInformation,
  DeviceHeader,
  MainCardBody,
  StyledHeader,
  StyledLeftBlock,
  SavantIcon,
} from '../styles'
import DeviceUID from './DeviceUID'
import { homeDeviceInformationMessages as messages } from '../messages'
import DeviceMainInformationCard from './DeviceMainInformationCard'
import { EquipmentUpdate } from '@racepointenergy/swc/scs/types/host'
import { UiDeviceStates } from '@racepointenergy/swc/scs/features/host-states'

interface DeviceMainInformationProps {
  equipmentUpdate?: EquipmentUpdate
  uiDevice?: UiDeviceStates
  isSavantBranded: boolean
}

function DeviceMainInformation({
  equipmentUpdate,
  uiDevice,
  isSavantBranded,
}: DeviceMainInformationProps) {
  return (
    <CardInformation>
      <StyledHeader>
        <StyledLeftBlock>
          <DeviceHeader bold>
            {equipmentUpdate?.Name ||
              equipmentUpdate?.UniqueID ||
              uiDevice?.Name?.value ||
              uiDevice?.id}
          </DeviceHeader>
          {isSavantBranded && <SavantIcon />}
        </StyledLeftBlock>
      </StyledHeader>
      <MainCardBody>
        <DeviceUID
          uid={equipmentUpdate?.UniqueID || uiDevice?.id}
          isSavant={isSavantBranded}
        />
        <DeviceMainInformationCard
          label={messages.deviceTypeLabel}
          value={
            equipmentUpdate?.DeviceType ||
            equipmentUpdate?.ChassisDeviceType ||
            uiDevice?.DeviceType?.value
          }
        />
        <DeviceMainInformationCard
          label={messages.deviceModelLabel}
          value={equipmentUpdate?.DeviceModel ?? uiDevice?.DeviceModel?.value}
        />
        <DeviceMainInformationCard
          label={messages.deviceZoneLabel}
          value={
            equipmentUpdate?.configPlacedZone || uiDevice?.CurrentZone?.value
          }
        />
      </MainCardBody>
    </CardInformation>
  )
}

export default memo(DeviceMainInformation)
